import React from 'react';

import { BasicNumberInput, BasicNumberInputProps } from './basic-number-input';

type ZoneCategoryTargetFrequencyInputProps = BasicNumberInputProps;

export const ZoneCategoryTargetFrequencyInput = ({ ...rest }: ZoneCategoryTargetFrequencyInputProps) => {
  const label = 'Target frequency';

  return <BasicNumberInput label={label} {...rest} />;
};
